import { component, demoFile, variant, componentWithVariants } from "system/demo";
import { CloseConversationFeature, ClosedConversationBanner } from 'feature/question/close-conversation';

demoFile('feature/question/close-conversation');

componentWithVariants('ClosedConversationBanner', ClosedConversationBanner, {}, [
    variant(null, {
        config: CloseConversationFeature.defaultConfig
    })
])
